import  api, { globalErrorHandler } from "../Api"

export const GET_KUDOS_MESSAGES = "GET_KUDOS_MESSAGES";
export const GET_KUDOS_SETTINGS = "GET_KUDOS_SETTINGS";
export const GET_KUDOS_CORRECTIONS = "GET_KUDOS_CORRECTIONS";
export const GET_KUDOS_SUGGESTION_MESSAGES = "GET_KUDOS_SUGGESTION_MESSAGES";
export const ADD_KUDOS_MESSAGE = "ADD_KUDOS_MESSAGE";
export const GET_KUDOS_BYID = "GET_KUDOS_BYID";
export const UPDATE_KUDOS_MESSAGE = "ADD_KUDOS_MESSAGE";
export const KU_LOADING = "KU_LOADING";
export const KU_LOADINGBYID = "KU_LOADINGBYID";
export const KU_ERROR = "KU_ERROR";

const config = {
  headers: {
      'content-type': 'application/json',
  }
};

export const GetKudosMessages = () => {
  
  return async dispatch => {
    dispatch({
      type: KU_LOADING
    });
    await api.get(`/HomeMessage`,config).then(res => 
      dispatch({
        type: GET_KUDOS_MESSAGES,
        data: res.data
        })
      ).catch(globalErrorHandler); 
  };
};

export const GetKudosSettings = () => {
  
  return async dispatch => {
    dispatch({
      type: KU_LOADING
    });
    await api.get(`/HomeMessage/GetKudosSettings`,config).then(res => 
      dispatch({
        type: GET_KUDOS_SETTINGS,
        data: res.data
        })
      ).catch(globalErrorHandler); 
  };
};

export const GetKudosCorrections = () => {
  
  return async dispatch => {
    dispatch({
      type: KU_LOADING
    });
    await api.get(`/HomeMessage/GetKudosCorrections`,config).then(res => 
      dispatch({
        type: GET_KUDOS_CORRECTIONS,
        data: res.data
        })
      ).catch(globalErrorHandler); 
  };
};

export const GetKudosSuggestionMessages = () => {
  
  return async dispatch => {
    dispatch({
      type: KU_LOADING
    });
    await api.get(`/HomeMessage/GetKudosSuggestionMessages`,config).then(res => 
      dispatch({
        type: GET_KUDOS_SUGGESTION_MESSAGES,
        data: res.data
        })
      ).catch(globalErrorHandler);
  };
};

export const AddKudosMessage = (payload) => {
  //console.log("addver", payload, files)
  return async dispatch => {
      dispatch({
          type: KU_LOADING
      });

      api.post(`/HomeMessage`, 
      payload, config).then(res => {
          dispatch({
              type: ADD_KUDOS_MESSAGE,
              payload: res.data
          });
          //console.log(res.data)
          // history.push(`/Benefits/FormAdminBenefits/${res.data}`);
      })
      .catch((error) => {
        globalErrorHandler(error);
        dispatch({
          type: KU_ERROR 
        })
      });
  };
};

export const GetKudosById = (id) => {
  const config = {
      headers: {
          'content-type': 'application/json',
      }
    }  
  return async dispatch => {
    dispatch({
      type: KU_LOADINGBYID
    });
    await api.get(`/HomeMessage/GetById/${id}`,config).then(res => {
      dispatch({
        type: GET_KUDOS_BYID,
        data: res.data
      });

      //console.log("categoriesaction", res.data)
    })
    .catch((error) => {
      globalErrorHandler(error);
      dispatch({
        type: KU_ERROR 
      })
    });
  };
};

export const UpdateKudosMessage = (payload) => {
  //console.log("addver", payload, files)
  return async dispatch => {
      dispatch({
          type: KU_LOADING
      });

      api.put(`/HomeMessage`, 
      payload, config).then(res => {
          dispatch({
              type: UPDATE_KUDOS_MESSAGE,
              payload: res.data
          });
          //console.log(res.data)
          // history.push(`/Benefits/FormAdminBenefits/${res.data}`);
      })
      .catch((error) => {
        globalErrorHandler(error);
        dispatch({
          type: KU_ERROR 
        })
      });
  };
};